import { render, staticRenderFns } from "./modalVerMas.vue?vue&type=template&id=a98d994e&"
import script from "./modalVerMas.vue?vue&type=script&lang=js&"
export * from "./modalVerMas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports